import React, { useState, useEffect, useContext } from 'react'
import { SeasonSection, Season, Header, Body, StarIcon, List } from '../styles/stars'
import { LocaleContext } from '../routes'
import { PlanetImage } from '../styles/image'
import { LabelExtra } from '../styles/elements'
import starIcon from '../assets/icons/star.svg'
import expandIcon from '../assets/icons/expand_base.svg'
import { getPersianNumber } from '../utils/number'
import { getSeasonTransactions } from "../api"
import TransactionItem from './TransactionItem'
import { Toggle } from '../styles/giftList'

const useTransactions = (id) => {
  const [transactions, setTransactions] = useState()
  useEffect(() => {
    const getTransactions = async () => {
      const transactionsResponse = await getSeasonTransactions(id)
      setTransactions(transactionsResponse)
    }
    getTransactions()
  }, [id])
  return transactions
}

export default ({ season }) => {
  const locale = useContext(LocaleContext)
  const transactions = useTransactions(season.id)
  const [isListCollapsed, setListCollapsed] = useState()
  const toggle = () => setListCollapsed(!isListCollapsed)

  return (
    <SeasonSection onClick={toggle}>
      <Header>
        <PlanetImage src={require(`../planets/${season.tier.type.toLowerCase()}.png`)} className="small" />
        <LabelExtra bold lh="1rem">{locale.LAND + locale[season.tier.type]}</LabelExtra>
        <Season>{season.title.split(' ')[0]}</Season>
        <Toggle src={expandIcon} alt="" collapsed={isListCollapsed} className="star" />
      </Header>
      {isListCollapsed ?
        <List>
          {transactions && transactions.transactions.map((transaction, index) =>
            <TransactionItem
              key={index}
              title={transaction.title}
              date={(new Date(transaction.createdAt)).toLocaleString('fa-IR')}
              price={transaction.point}
              isGain={transaction.point > 0}
            />
          )}
        </List>
        :
        <Body>
          <div>
            {locale.SUM_STARS}:
            <StarIcon alt="*" src={starIcon} faded />
            {getPersianNumber(season.point.amount)}
          </div>
          <div>
            {locale.EXPIRATION_DATE + ": "}
            {new Date(season.point.expirationDate).toLocaleDateString('fa-IR')}
          </div>
        </Body>
      }
    </SeasonSection>
  )
}